import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"

import AgreementCheckBox from "../AgreementCheckBox"
import { currentStepTitle, OnboardingStepId } from "../constants"
import IFrame from "../IFrame"
import SignatureField from "../SignatureField"
import { getAgreementURL } from "../utils"

const PRIVACY_POLICY_URL = getAgreementURL({ type: "privacy-policy" })

const PrivacyPolicy = ({ onLoaded }: { onLoaded: () => void }) => {
  const form = useFormContext()

  const url = useMemo(() => {
    const url = new URL(PRIVACY_POLICY_URL)
    url.searchParams.set("embed", "true")
    return url.toString()
  }, [])

  return (
    <div className="h-auto min-h-full">
      <IFrame
        id="privacy-policy-iframe"
        url={url}
        onLoaded={onLoaded}
        render={({ isLoading }) => {
          if (!isLoading) {
            return (
              <div className="mt-3 flex flex-col gap-2">
                <SignatureField />
                <Controller
                  key="privacyPolicy"
                  control={form.control}
                  name="privacyPolicy"
                  render={({ field, fieldState: { error } }) => (
                    <AgreementCheckBox
                      onChange={field.onChange}
                      ref={field.ref}
                      value={field.value}
                      errorMessage={error?.message}
                      title={`I have read and agree to the ${
                        currentStepTitle[OnboardingStepId.privacyPolicy]
                      }`}
                    />
                  )}
                />
              </div>
            )
          }
          return null
        }}
      />
    </div>
  )
}

export default PrivacyPolicy
